<template>
	<div class="runner row" style="gap: 5px; align-items: start;">
		<!-- TODO: link to item {{ target.sys.id }} / {{ runner }} -->
		<!--<button>item</button>-->
		<div style="width: 60px; font-size: smaller;">{{ runner }}</div>
		<button
			:disabled="loading || runner != 'karate'"
			class="run-btn"
			@click.stop.prevent="triggerExecution"
			title="Trigger execution"
		>
			<template v-if="loading">&hellip;</template>
			<template v-else>▶</template>
		</button>
		<JsonAutotestTimeline
			:key="target.sys.id + '-' + runner + '-' + update"
			v-model="localTimelineModel"
			:runner="runner"
			:testcase="testcase"
			:target="target"
			:showScale="showScale"
		/>
		<!--<button>Run Now</button>-->
	</div>
</template>

<script>
import JsonAutotestTimeline from './JsonAutotestTimeline.vue'

export default {
	name: 'JsonAutotestRunnerRow',
	components: { JsonAutotestTimeline },
	inject: [ 'defaultLocale' ],
	props: {
		runner: String,
		target: Object,
		testcase: Object,
		timelineModel: Object,
		showScale: Boolean,
		schedule: String,
	},
	data: () => ({
		loading: false,
		update: 0,
	}),
	computed: {
		localTimelineModel: {
			get() { return this.timelineModel },
			set(val) { this.$emit('update:timelineModel', val) },
		},
	},
	methods: {
		updateTimeline() {
			this.timelineModel.toDate = new Date().toISOString()
			this.update++
		},
		async triggerExecution() {
			if (this.loading) return
			this.loading = true
			
			const entry = this.target
			const runner = this.runner
			
			const spaceId = this.testcase?.sys?.space?.sys?.id
			const metisId = entry.fields.metisId?.[this.defaultLocale]
			const scheduleName = this.schedule
			const target = entry.fields.type?.[this.defaultLocale]
			const testcaseId = this.testcase.sys.id
			const executionId = 'exec-' + metisId + '-' + testcaseId + '-' + target + '-' + new Date().toISOString().replace(/[^0-9]/g, '')

			if (!spaceId || !metisId || !target || !scheduleName) {
				console.error('Missing data for execution trigger', { spaceId, metisId, scheduleName, target })
				this.loading = false
				return
			}

			try {
				console.log('trigger execution', { spaceId, metisId, scheduleName, target, testcaseId, executionId })
				await this.$httpPost('https://autotest-zabbix-gw.tools.contenthub.dev/trigger/executions', {
					space_id: spaceId,
					metis_id: metisId,
					schedule_name: scheduleName,
					target: target,
					testcase_id: testcaseId,
					execution_id: executionId,
				})
				let retries = 0
				this.updateTimeline()
				while (true) {
					try {
						const r = await this.$httpGet('https://autotest-zabbix-gw.tools.contenthub.dev/runner/execution/' + executionId + '/')
						if (r.testResult >= 0) {
							console.log('execution result', r)
							// TODO: expose result somehow
							this.updateTimeline()
							break
						}
						if (retries >= 30) {
							console.error('Max retries reached for execution status check', executionId)
							break
						}
					}
					catch (e) {
						console.error(e)
					}
					await new Promise(resolve => setTimeout(resolve, 10000))
					retries++
					
					// Safety break if component destroyed?
					// Ideally we should handle cancellation, but we just follow existing logic for now.
				}
			}
			catch (e) {
				console.error(e)
			}
			finally {
				this.loading = false
			}
		},
	},
}
</script>

<style scoped>
.row { display: flex; gap: 10px; align-items: center; padding-top: 3px; }
button { padding: 7px 10px; border-radius: 5px; background: var(--color-element-dark); color: white; border: 0; }
button.run-btn { background: var(--color-blue-mid); cursor: pointer; padding: 4px 2px; font-size: 10px; height: 15px; width: 20px; display: inline-flex; align-items: center; justify-content: center; }
button.run-btn:hover { background: var(--color-blue-base); }
</style>
